import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QRCodeModule } from 'angularx-qrcode';

@Component({
  selector: 'shared-qr',
  standalone: true,
  imports: [CommonModule, QRCodeModule],
  templateUrl: './qr.component.html',
})
export class QrComponent {
  @Input()
  public qrData!: string;

  @Input()
  public width: number = 256;

  @Input()
  public errorCorrectionLevel: 'M' | 'L' | 'Q' | 'H' = 'M';
}
